import longClick from './directives/longclick';

export const longClickDirective = longClick
